import tw, { styled } from 'twin.macro';

const Container = styled.div<{ noShadow?: boolean }>`
  ${tw`shadow sm:rounded-md mb-6 py-6 px-4 sm:p-6 relative`}
  ${({ noShadow }) => noShadow && tw`shadow-none`}
`;

export default Container;
